import React from 'react';
import { HeartIcon } from '@heroicons/react/24/solid';

/**
 * Rami-Care Logo Component
 * Professional healthcare brand logo with consistent styling
 */
const RamiCareLogo = ({ size = 'md', showText = true, className = '' }) => {
  const sizes = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-16 h-16 text-2xl',
    xl: 'w-24 h-24 text-4xl',
    '2xl': 'w-32 h-32 text-5xl',
  };

  const textSizes = {
    sm: 'text-sm',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl',
    '2xl': 'text-4xl',
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Logo Icon with Gradient */}
      <div
        className={`${sizes[size]} bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105 relative overflow-hidden group`}
      >
        {/* Animated Background Shine */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
        
        {/* Heart Icon for Care */}
        <HeartIcon className={`${size === 'sm' ? 'w-4 h-4' : size === 'md' ? 'w-5 h-5' : size === 'lg' ? 'w-8 h-8' : size === '2xl' ? 'w-16 h-16' : 'w-12 h-12'} text-white relative z-10`} />
      </div>

      {/* Brand Text */}
      {showText && (
        <div className="flex flex-col leading-tight">
          <span className={`${textSizes[size]} font-bold text-gray-900`}>
            <span className="bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
              Rami-Care
            </span>
          </span>
          {size !== 'sm' && (
            <span className="text-xs text-emerald-600 font-medium">
              שותפים בבריאות
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default RamiCareLogo;


